import { Trans } from '@ecomm/i18n'
import type { ReactNode } from 'react'
import { PerDaySlash } from '../A11yHelpers/PerDaySlash'

const Slash = () => (
  <>
    <PerDaySlash />
    <br className="md:hidden" />
  </>
)

export function ComparisonFooterCell({
  children
}: { readonly children: ReactNode }) {
  return (
    <td
      className="border-r last:border-r-0 border-0 border-solid border-neutral-medium font-bold text-sm md:text-2xl pt-2 pb-0 md:pt-6 py-1 flex items-center justify-center"
      data-testid="ComparisonFooterCell"
    >
      <Trans components={{ per: <Slash /> }} parent="span">
        {children}
      </Trans>
    </td>
  )
}
